import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { wait } from "../utility/wait";

interface EventRelationQuestionProps {
  eventRelation: boolean | null;
  setEventRelation: React.Dispatch<React.SetStateAction<boolean | null>>;
  isAutoPageTurn?: boolean;
  questionnairePage: number;
  switchTab: (next: number) => void;
}

export const EventRelationQuestion: React.FC<EventRelationQuestionProps> = ({
  eventRelation,
  setEventRelation,
  isAutoPageTurn,
  questionnairePage,
  switchTab,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setEventRelation(event.target.value === "true");
    if (isAutoPageTurn) {
      await wait(100);
      switchTab(questionnairePage + 1);
    }
  };

  return (
    <>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="caption">
          思い出した良い出来事は、あなたの周囲の人にも関係していますか？
        </Typography>
      </Box>
      <Box sx={{ padding: "1rem" }}>
        <FormControl>
          <RadioGroup
            onChange={handleChange}
            value={eventRelation === null ? "null" : eventRelation.toString()}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="はい（関係している）"
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="いいえ（関係していない）"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </>
  );
};
